import React from 'react';
import { Overlay } from './Overlay';
import { useI18n } from '../i18n/I18nContext';
import { Announcement } from '../services/AnnouncementService';

interface AnnouncementOverlayProps {
  announcement: Announcement;
  onDismiss: () => void;
}

export const AnnouncementOverlay: React.FC<AnnouncementOverlayProps> = ({
  announcement,
  onDismiss,
}) => {
  const { t } = useI18n();

  const getPriorityIcon = () => {
    switch (announcement.priority) {
      case 'high':
        return '⚠️';
      case 'low':
        return 'ℹ️';
      default:
        return '📢';
    }
  };

  return (
    <div
      className="overlay-backdrop"
      style={{ zIndex: 3000 }} // Higher than other overlays
    >
      <div
        className="overlay announcement-overlay"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: '500px' }}
      >
        <div className="overlay-header">
          <h2>
            <span style={{ marginRight: '8px' }}>{getPriorityIcon()}</span>
            {announcement.title}
          </h2>
        </div>

        <div className="overlay-content">
          <div style={{ whiteSpace: 'pre-wrap', marginBottom: '20px' }}>
            {announcement.message}
          </div>

          <div style={{ textAlign: 'center' }}>
            <button
              onClick={onDismiss}
              className="btn-primary"
              style={{
                padding: '12px 40px',
                fontSize: '16px',
                cursor: 'pointer',
              }}
            >
              {t('announcement.ok')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
